import * as React from "react";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//fix odd favIcons bug

const PermissionDenied = () => {
    return (
        <Container className="d-flex flex-fill align-items-center">
            <Row className="w-100">
                <Col md={8} lg={5} className="mx-auto">
                    <Card className="shadow-sm rounded p-4 border-0">
                        <Card.Body className="text-center d-flex flex-column justify-content-center">
                            <div className="dapp-icon icon-medium">
                                <FontAwesomeIcon
                                    icon={faBan}
                                    className="mx-auto text-muted fa-3x"
                                />
                            </div>
                            <span className="h4 empty-heading mt-3">
                                Permission Denied
                            </span>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default PermissionDenied;
